module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("WpWIX"))).then(() => parcelRequire('8rm4T'));